import React from "react";
import { NavLink, useParams } from "react-router-dom";

import { useTicket } from "hooks/tickets";

import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Skeleton,
  Grid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";

const ViewTicket = () => {
  const { id } = useParams();
  const { isFetching: isLoading, data } = useTicket(id);

  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Flex
      direction="column"
      minH="100vh"
      align="center"
      pt={{ sm: "120px", lg: "160px" }}
    >
      <Card w={{ md: "100%", lg: "50%" }}>
        <CardHeader mb="40px">
          <Flex direction="row" w="100%" justify="space-between">
            <Text
              color={textColor}
              fontSize="lg"
              fontWeight="bold"
              mb="3px"
            >
              Ticket #{id}
            </Text>
            <NavLink to="/sistema/suporte">
              <Button >
                Voltar
              </Button>
            </NavLink>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Grid
              templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}
              templateRows={{ md: "repeat(1, 1fr)" }}
              gap="24px"
            >
              <FormControl >
                <FormLabel
                  color={textColor}
                  fontWeight="bold"
                  fontSize="xs"
                >
                  Status
                </FormLabel>
                <Skeleton height={"25px"} isLoaded={!isLoading}>
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="3px"
                  >
                    { data && data.status ? data.status.toUpperCase() : null }
                  </Text>
                </Skeleton>
              </FormControl>
              <FormControl >
                <FormLabel
                  color={textColor}
                  fontWeight="bold"
                  fontSize="xs"
                >
                  Proridade
                </FormLabel>
                <Skeleton height={"25px"} isLoaded={!isLoading}>
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="3px"
                  >
                    { data && data.priority ? data.priority.toUpperCase() : null }
                  </Text>
                </Skeleton>
              </FormControl>
            </Grid>
            <Grid
              templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
              templateRows={{ md: "repeat(1, 1fr)" }}
              gap="24px"
              mt="24px"
            >
              <FormControl >
                <FormLabel
                  color={textColor}
                  fontWeight="bold"
                  fontSize="xs"
                >
                  Onde encontrou o erro?
                </FormLabel>
                <Skeleton height={"25px"} isLoaded={!isLoading}>
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="3px"
                  >
                    { data?.content?.source || null}
                  </Text>
                </Skeleton>
              </FormControl>
              <FormControl >
                <FormLabel
                  color={textColor}
                  fontWeight="bold"
                  fontSize="xs"
                >
                  O que o erro causa?
                </FormLabel>
                <Skeleton height={"25px"} isLoaded={!isLoading}>
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="3px"
                  >
                    { data?.content?.causes || null}
                  </Text>
                </Skeleton>
              </FormControl>
              <FormControl >
                <FormLabel
                  color={textColor}
                  fontWeight="bold"
                  fontSize="xs"
                >
                  Resuma o erro encontrado
                </FormLabel>
                <Skeleton height={"25px"} isLoaded={!isLoading}>
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="3px"
                  >
                    { data?.content?.abstract || null}
                  </Text>
                </Skeleton>
              </FormControl>
            </Grid>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  )
}

export default ViewTicket